module.exports = __webpack_public_path__ + "static/media/Invoice.20e756a5.svg";